export default __webpack_public_path__ + "static/media/instagram.a062d315.svg";